/**
 * Central kill-switches for features that must be deactivatable without
 * deleting code. Flip the constant and every entry point (buttons, routes,
 * cards) gates itself.
 */

/**
 * #2882 — tariff optimiser deactivated 2026-09-01 (meeting 2026-08-29, action
 * #5). No live provider-price API exists yet, so bill-upload analyses can't be
 * verified against real vendor tariffs and the AI's switching recommendations
 * aren't trustworthy. Returns behind this flag once a price source is
 * integrated — before 15 Sep if the API research lands, otherwise v2.0.
 */
export const TARIFF_OPTIMIZATION_ENABLED = false;
